import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import type {
  OrdersResponseType,
  OrdersSearchParamsType,
} from "@/types/orders"
import { StringHelper } from "@/utils"
type useOrdersParamsType = Omit<
  OrdersSearchParamsType,
  "from" | "to"
>
export const getOrders = async (
  params: useOrdersParamsType
) => {
  const newParams = {
    ...params,
    customerDocument: StringHelper.onlyAlphanumeric(
      params?.customerDocument
    ),
  }
  const queryString =
    StringHelper.objectToQueryString(newParams)
  const url = `${ENDPOINTS.ORDER_BY_FILTER}?${queryString}`
  const { data } = await api.get<OrdersResponseType>(url)
  return data
}
const useOrdersByFilter = (
  params: useOrdersParamsType,
  enabled = false
) => {
  const queryString = useMemo(() => {
    const safeParams = {
      ...params,
      customerDocument: StringHelper.onlyAlphanumeric(
        params?.customerDocument
      ),
    }
    return StringHelper.objectToQueryString(safeParams)
  }, [params])

  return useQuery({
    queryKey: [
      ENDPOINTS.ORDER_BY_FILTER,
      queryString,
      params.refetch,
    ],
    queryFn: () => getOrders(params),
    enabled: enabled && !!params.refetch,
  })
}
export default useOrdersByFilter
